// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"OrderGroupStatus_statusIcon__28F8p","active":"OrderGroupStatus_active__30kL5","img":"OrderGroupStatus_img__3WuFA"};